export default __webpack_public_path__ + "static/media/beeSQL_Left_Justified.c84504bc.png";